import PreviewNav from '@/components/preview/PreviewNav'

export default function Navigation() {
  return <PreviewNav />
}
